var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"main-layout back-blue"},[_c('notifications'),_c('Menu'),_c('div',{staticClass:"content"},[_c('router-view',{staticClass:"width100"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }